import React from 'react';
import CloseableModal from 'Components/CloseableModal';
import { IonContent, IonGrid, IonRow } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Button';

export interface CaseOrganizationWorkerModalData {
	index: number;
	title: string;
	name: string;
}

export interface Props {
	worker: CaseOrganizationWorkerModalData | undefined;
	remove: (index: number) => void;
	onDismiss: () => void;
}
const RemoveWorkerModal: React.FC<Props> = ({ worker, remove, onDismiss }) => {
	const { t } = useTranslation();
	return (
		<CloseableModal title="Fjern medarbejder" onDismiss={onDismiss}>
			<IonContent>
				<IonRow className="text-xl text-blue-calm mb-10">Du er ved at fjerne følgende medarbejder fra sagsorganisationen:</IonRow>
				<IonRow className="text-lg  ">
					{t('reports.asbestos.title')}: {worker?.title}
				</IonRow>
				<IonRow className="text-lg mb-10">
					{t('reports.asbestos.name')}: {worker?.name}
				</IonRow>

				<IonRow className="text-xl text-blue-calm mb-4">{t('reports.asbestos.wantToRemoveWorker')}</IonRow>
				<IonRow>
					<Button
						className="w-full"
						onClick={() => {
							remove(worker!.index);
							onDismiss();
						}}
					>
						{t('common.remove')}
					</Button>
				</IonRow>
				<IonRow>
					<Button
						className="w-full"
						onClick={() => {
							onDismiss();
						}}
					>
						{t('reports.asbestos.cancel')}
					</Button>
				</IonRow>
			</IonContent>
		</CloseableModal>
	);
};

export default RemoveWorkerModal;
